import React from "react";
import WebhookList from "../Webhook/WebhookList";
import "./OrgPopup.css";


const OrgWebhookPopup = (props) => {
  const orgId = parseInt(props.id) || parseInt(props.record.id) || null;
  return (
    <div>
      <div class="bg-overlay" onClick={props.onclickoutside} />
      <div class="org-popup">
            <h3>Available Webhooks</h3>
            <WebhookList
              orgId={orgId}
              filter={{ org_id: orgId, mode: "available" }}
              can_add={true}
              can_remove={false}
            />
            <h3>Associated Webhooks</h3>
            <WebhookList
              orgId={orgId}
              filter={{ org_id: orgId, mode: "associated" }}
              can_add={false}
              can_remove={true}
            />
            <h3>Owned Webhooks</h3>
            <WebhookList orgId={orgId} filter={{ org_id: orgId }} />
          </div>
          <div>
      </div>
    </div>
  );
};

export default OrgWebhookPopup;
